const FIELD_LABELS: Record<string, string> = {
	builderEnabled: 'Билдер',
	dailyBuildLimit: 'Лимит сборок',
	defaultBuilderIcons: 'Иконки по умолчанию',
	encryptEnabled: 'Шифрование',
	encryptDexloader: 'Dexloader',
	payloadEncryptEnabled: 'Шифрование payload',
	payloadEncryptDexloader: 'Dexloader payload',
	payloadEncryptAssets: 'Шифрование assets payload',
	payloadEncryptRenamePackage: 'Переименование пакета payload',
	encryptAssets: 'Шифрование assets',
	encryptRenamePackage: 'Переименование пакета',
	testBuildEnabled: 'Тестовый билд',
	variant: 'Версия APK',
	domainsEnabled: 'Добавление доменов',
	domainCloudflareApiToken: 'Cloudflare API Token',
	domainCloudflareOriginCaKey: 'Cloudflare Origin CA Key',
	domainCloudflareAccountId: 'Cloudflare Account ID',
	domainOriginIp: 'Origin IP',
	domainDailyLimitPerUser: 'Лимит доменов на пользователя',
	domainCheckIntervalMs: 'Интервал проверки DNS',
	domainNsTimeoutDays: 'Таймаут ожидания NS',
	landingDomainCheckIntervalMs: 'Интервал проверки DNS лендингов',
	landingDomainNsTimeoutDays: 'Таймаут ожидания NS лендингов',
};

type ZodIssueLike = {
	path?: unknown[];
	message?: string;
	code?: string;
};

function fieldLabel(path: unknown[] | undefined): string {
	const field = path?.[0];
	if (typeof field === 'string') {
		return FIELD_LABELS[field] ?? field;
	}
	return 'Поле';
}

function formatIssue(issue: ZodIssueLike): string {
	const label = fieldLabel(issue.path);

	if (issue.message) {
		return `${label}: ${issue.message}`;
	}

	switch (issue.code) {
		case 'invalid_type':
			return `${label}: некорректный тип значения`;
		case 'too_small':
			return `${label}: значение слишком мало`;
		case 'too_big':
			return `${label}: значение слишком велико`;
		default:
			return `${label}: некорректное значение`;
	}
}

function formatZodIssues(issues: ZodIssueLike[]): string {
	const messages = issues.map(formatIssue);
	return messages.length > 0 ? messages.join('; ') : 'Некорректные данные запроса';
}

function parseZodErrorMessage(message: string): string | null {
	try {
		const parsed = JSON.parse(message) as unknown;
		if (Array.isArray(parsed)) {
			return formatZodIssues(parsed as ZodIssueLike[]);
		}
	} catch {
		// not JSON
	}
	return null;
}

export function formatApiError(data: unknown): string | null {
	if (!data || typeof data !== 'object') {
		return null;
	}

	const record = data as Record<string, unknown>;

	if (typeof record.message === 'string' && record.message.trim()) {
		return record.message;
	}

	if (record.success === false && record.error && typeof record.error === 'object') {
		const error = record.error as Record<string, unknown>;
		if (error.name === 'ZodError' && typeof error.message === 'string') {
			const formatted = parseZodErrorMessage(error.message);
			if (formatted) {
				return formatted;
			}
			return error.message;
		}
	}

	return null;
}
